import { defineMessages } from 'react-intl'

const scope = `procurify.platform.import-export.pages`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  exportDataTitle: {
    id: `${scope}.exportDataTitle`,
    defaultMessage: 'Export data as CSV',
  },
  requestedExportsTitle: {
    id: `${scope}.requestedExportsTitle`,
    defaultMessage: 'Requested CSVs',
  },
  pagePlaceholder: {
    id: `${scope}.pagePlaceholder`,
    defaultMessage: 'Loading…',
  },
  accessErrorTitle: {
    id: `${scope}.accessErrorTitle`,
    defaultMessage: 'Access restricted',
  },
  accessErrorMessage: {
    id: `${scope}.accessErrorMessage`,
    defaultMessage: 'Permission required to access this page',
  },
  // Per-type breadcrumb labels keyed by config.key — Angular breadcrumb
  // parity (Settings → Download data as CSV → <type title>); copy mirrors
  // the landing-row titles (BHV-036 guard resolves the descriptor).
  orderItemsLabel: {
    id: `${scope}.orderItemsLabel`,
    defaultMessage: 'Order items',
  },
  poItemsLabel: {
    id: `${scope}.poItemsLabel`,
    defaultMessage: 'Purchase order items',
  },
  expenseReportHistoryLabel: {
    id: `${scope}.expenseReportHistoryLabel`,
    defaultMessage: 'Expense report history',
  },
  travelHistoryLabel: {
    id: `${scope}.travelHistoryLabel`,
    defaultMessage: 'Travel history',
  },
  budgetLabel: {
    id: `${scope}.budgetLabel`,
    defaultMessage: 'Budgets',
  },
  receivingHistoryLabel: {
    id: `${scope}.receivingHistoryLabel`,
    defaultMessage: 'Receiving history',
  },
  catalogLabel: {
    id: `${scope}.catalogLabel`,
    defaultMessage: 'Catalog',
  },
  billsLabel: {
    id: `${scope}.billsLabel`,
    defaultMessage: 'Bills',
  },
  usersLabel: {
    id: `${scope}.usersLabel`,
    defaultMessage: 'Users',
  },
  locationsLabel: {
    id: `${scope}.locationsLabel`,
    defaultMessage: 'Locations',
  },
  receiveLogLabel: {
    id: `${scope}.receiveLogLabel`,
    defaultMessage: 'Receive log',
  },
  unbilledPoItemsLabel: {
    id: `${scope}.unbilledPoItemsLabel`,
    defaultMessage: 'Unbilled PO items (Accruals Report)',
  },
  auditImportLogLabel: {
    id: `${scope}.auditImportLogLabel`,
    defaultMessage: 'Import audit logs',
  },
  adminAuditLogLabel: {
    id: `${scope}.adminAuditLogLabel`,
    defaultMessage: 'Procurify administrator audit logs',
  },
  superuserAuditLogLabel: {
    id: `${scope}.superuserAuditLogLabel`,
    defaultMessage: 'Superuser audit logs',
  },
  spendingCardTransactionsLabel: {
    id: `${scope}.spendingCardTransactionsLabel`,
    defaultMessage: 'Spending card transactions',
  },
  budgetsRedesignedLabel: {
    id: `${scope}.budgetsRedesignedLabel`,
    defaultMessage: 'Budget setup',
  },
  spendDataRedesignedLabel: {
    id: `${scope}.spendDataRedesignedLabel`,
    defaultMessage: 'Budget spend breakdown',
  },
  contractsLabel: {
    id: `${scope}.contractsLabel`,
    defaultMessage: 'Contracts',
  },
})
